import { USE_API_MOCKS } from '../env';
import { API_URL } from '@api/apiDictionary';
import { RESTClient, RESTClientMock } from '@api/client';

import { fetchUsersListMock } from '@api/mocks/users';
import { UserItemForMembers } from '@dynamika-shared/types/users';
import { TeamRoles } from 'src/constants/rolesList';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchUsersAffiliationList = (
  clinicalTrialId: string,
  role: TeamRoles,
  filter?: string
) => {
  if (USE_API_MOCKS) {
    fetchUsersListMock(filter);
  }

  return api.get<UserItemForMembers[]>(
    API_URL.usersAffiliation.replace(':id', clinicalTrialId),
    {
      params: { role, filter },
    }
  );
};
